<template lang="pug">
	#componenteMapa
		link(rel="stylesheet" href="https://unpkg.com/leaflet@1.2.0/dist/leaflet.css")
		fullscreen(:fullscreen.sync="fullscreen")
			el-row#mapa
				el-col(:span="18" v-bind:class="{'el-col-24': !painelCamadas}").mapa
					div(v-bind:id="idMapa").map
						#ano1.ano
							el-select(v-model="ano1")
								el-option(v-for="item in retornaOptions1"
								:key="item.value"
								:label="item.label"
								:value="item.value")
						#ano2.ano
							el-select(v-model="ano2")
								el-option(v-for="item in retornaOptions2"
								:key="item.value"
								:label="item.label"
								:value="item.value")
				el-col(:xs='6', :sm='6', :md='6' :lg='6' v-if="this.painelCamadas").layers
					h2#title Camadas
					el-tree(:data="groups" ref="tree" :props="defaultProps" @node-click="layerChange" :render-content="renderContent")

</template>

<script>

import MapaService from '../../utils/services/mapa.service'
import * as L from 'leaflet'
import EyeIcon from 'vue-material-design-icons-size/Eye'
import LayersIcon from 'vue-material-design-icons-size/Layers'

require('leaflet-side-by-side')
require('leaflet-easybutton')
var $ = require('jquery')

export default {
	name: 'Mapa',
	components: { LayersIcon, EyeIcon },
	props: {
		imovel: Object,
		idMapa: Number
	},
	data: function() {

		return {
			geradorId: -1,
			mapa: null,
			painelCamadas: false,
			side: null,
			ano1: '2008',
			ano2: '2011',
			titleLayer: null,
			layers: [],
			fullscreen: false,
			loading: true,
			groups: [{
				label: 'Cadastro Ambiental Rural',
				children: []
			}, {
				label: 'Restrições Ambientais',
				children: []
			}, {
				label: 'Áreas a serem regularizadas',
				children: []
			}, {
				label: 'Áreas antropizadas',
				classificada: true,
				children: []
			}],
			defaultProps: {
				children: 'children',
				label: 'label'
			},
			options: [{
				value: '2008',
				label: '2008'
			}, {
				value: '2011',
				label: '2011'
			}, {
				value: '2012',
				label: '2012'
			}, {
				value: '2013',
				label: '2013'
			}, {
				value: '2014',
				label: '2014'
			}, {
				value: '2015',
				label: '2015'
			}, {
				value: '2016',
				label: '2016'
			}]
		}

	},
	mounted() {

		this.initMap()
		this.adicionarSideBySide()
		// this.adicionaConfiguracoes()
		this.initLayers()
		this.focoMapaImovel()

	},
	watch: {
		ano1: function() {

			this.adicionarSideBySide()

		},
		ano2: function() {

			this.adicionarSideBySide()

		},
		fullscreen: function(newVal) {

			if(newVal) {

				$('#mapa').css('height', '100vh')

			} else {

				$('#mapa').css('height', '500px')

			}

			var that = this

			setTimeout(function() {

				that.mapa.invalidateSize()

			}, 0)

		}
	},
	computed: {
		retornaOptions1: function() {

			var that = this
			var options = this.options.slice()
			this.options.find(function(element, index, array) {

				if(element.value === that.ano2) {

					that.index = index

				}

			})

			options.splice(this.index, 1)

			return options

		},
		retornaOptions2: function() {

			var that = this
			var options = this.options.slice()
			this.options.find(function(element, index, array) {

				if(element.value === that.ano1) {

					that.index = index

				}

			})

			options.splice(this.index, 1)

			return options

		}
	},
	methods: {
		adicionaCamadasAreasRegularizadas() {

			MapaService.adicionaCamadasAreasRegularizadas(this.imovel, this.mapa, this.layers)

			this.adicionaCamadasAreasASeremRegularizadas()
			this.adicionaCamadasRestricoesAmbientais()
			this.adicionaCamadasAreasAntropizadas()
			this.adicionaCamadasCAR()

			if(!(this.groups[2].children.length > 0)) {

				this.groups.splice(2, 1)

			}

			this.loading = false

		},
		adicionaCamadasCAR() {

			var that = this

			var params = {
				'service': 'WMS',
				'format': 'image/png8',
				'version': '1.1.1',
				'minZoom': 6,
				'maxZoom': 15,
				'maxNativeZoom': 15,
				'url': 'http://car.semas.pa.gov.br/geoserver/classificacao/wms?',
				'transparent': 'TRUE'
			}

			var urls = [{
				nome: 'Área do imóvel',
				layers: 'secar-pa:imovel',
				ativo: true
			}, {
				nome: 'Remanescente de Vegetação Nativa',
				layers: 'classificacao:remanescente_vegetacao_nativa',
				cql_filter: 'idt_imovel=' + that.imovel.id,
				ativo: false
			}, {
				nome: 'Área de Pousio',
				layers: 'secar-pa:area_pousio',
				ativo: false
			}, {
				nome: 'Área de uso restrito para declividade de 25 a 45 graus',
				layers: 'secar-pa:area_uso_restrito_declividade',
				ativo: false
			}, {
				nome: 'Área de uso restrito para regiões pantaneiras',
				layers: 'secar-pa:area_uso_restrito_regioes_pantaneiras',
				ativo: false
			}, {
				nome: 'Curso d\'água natural de até 10 metros',
				layers: 'secar-pa:curso_dagua_ate_10_metros',
				ativo: false
			}, {
				nome: "Curso d'água natural de 10 a 50 metros",
				layers: 'secar-pa:curso_dagua_10_50_metros',
				ativo: false
			}, {
				nome: 'Curso d\'água natural de 50 a 200 metros',
				layers: 'secar-pa:curso_dagua_50_200_metros',
				ativo: false
			}, {
				nome: 'Curso d\'água natural de 200 a 600 metros',
				layers: 'secar-pa:curso_dagua_200_600_metros',
				ativo: false
			}, {
				nome: 'Curso d\'água natural acima de 600 metros',
				layers: 'secar-pa:curso_dagua_maior_600_metros',
				ativo: false
			}, {
				nome: 'Lago ou lagoa natural',
				layers: 'secar-pa:lago_lagoa_natural',
				ativo: false
			}, {
				nome: 'Nascente ou olho d\'água perene',
				layers: 'secar-pa:nascente_olho_dagua_perene',
				ativo: false
			}, {
				nome: 'Reservatório artificial decorrente de barramento ou represamento de cursos d\'água naturais',
				layers: 'secar-pa:reservatorio_artificial_barramento',
				ativo: false
			}, {
				nome: 'Manguezal',
				layers: 'secar-pa:manguezal',
				ativo: false
			}]

			urls.forEach(function(url) {

				params.layers = url.layers
				params.cql_filter = 'idt_imovel=' + that.imovel.id

				if(url.layers === 'secar-pa:imovel') {

					params.cql_filter = 'cod_imovel=' + "'" + that.imovel.codigo + "'"

				}

				var camada = L.tileLayer.wms('http://car.semas.pa.gov.br/geoserver/secar-pa/wms?', params).addTo(that.mapa)
				that.layers.push({
					id: camada._leaflet_id,
					name: url.nome,
					active: url.ativo,
					features: camada
				})
				that.groups[0].children.push({
					label: url.nome,
					id: camada._leaflet_id,
					ativo: url.ativo,
					feature: camada
				})

				if(!url.ativo) {

					that.mapa.removeLayer(camada)

				}

			})

		},
		adicionaCamadasAreasAntropizadas() {

			var that = this

			var params = {
				'service': 'WMS',
				'format': 'image/png8',
				'version': '1.1.1',
				'layers': 'classificacao:area_antropizada_pa_2008_2016',
				'minZoom': 6,
				'maxZoom': 15,
				'maxNativeZoom': 15,
				'url': 'http://car.semas.pa.gov.br/geoserver/classificacao/wms?',
				'transparent': 'TRUE'
			}

			var urls = [{
				nome: '2008-2011',
				cql_filter: "ano_detec='2008-2011'",
				ativo: true
			}, {
				nome: '2011-2012',
				cql_filter: "ano_detec='2011-2012'",
				ativo: false
			}, {
				nome: '2012-2013',
				cql_filter: "ano_detec='2012-2013'",
				ativo: false
			}, {
				nome: '2013-2014',
				cql_filter: "ano_detec='2013-2014'",
				ativo: false
			}, {
				nome: '2014-2015',
				cql_filter: "ano_detec='2014-2015'",
				ativo: false
			}, {
				nome: '2015-2016',
				cql_filter: "ano_detec='2015-2016'",
				ativo: false
			}]

			urls.forEach(function(url) {

				params.cql_filter = url.cql_filter

				var camada = L.tileLayer.wms('http://car.semas.pa.gov.br/geoserver/classificacao/wms?', params).addTo(that.mapa)
				that.layers.push({
					id: camada._leaflet_id,
					name: url.nome,
					active: url.ativo,
					features: camada
				})
				that.groups[3].children.push({
					label: url.nome,
					id: camada._leaflet_id,
					ativo: url.ativo,
					feature: camada
				})

				if(!url.ativo) {

					that.mapa.removeLayer(camada)

				}

			})

		},
		adicionaCamadasRestricoesAmbientais() {

			var that = this

			var params = {
				'service': 'WMS',
				'format': 'image/png8',
				'version': '1.1.1',
				'minZoom': 6,
				'maxZoom': 15,
				'layers': '',
				'maxNativeZoom': 15,
				'transparent': 'TRUE'
			}

			var urls = [{
				nome: 'Unidade de Conservação',
				data: 'secar-pa:unidade_conservacao'
			}, {
				nome: 'Terras Indígenas',
				data: 'secar-pa:terra_indigena'
			}, {
				nome: 'Assentamentos',
				data: 'secar-pa:assentamentos_pa'
			}]

			urls.forEach(function(url) {

				params.layers = url.data
				var camada = L.tileLayer.wms('http://car.semas.pa.gov.br/geoserver/secar-pa/wms?', params).addTo(that.mapa)
				that.layers.push({
					id: camada._leaflet_id,
					name: url.nome,
					active: false,
					features: camada
				})
				that.groups[1].children.push({
					label: url.nome,
					id: camada._leaflet_id,
					ativo: false,
					feature: camada
				})

				that.mapa.removeLayer(camada)

			})

		},
		adicionaCamadasAreasASeremRegularizadas() {

			var that = this

			this.layers.forEach(function(layer) {

				if(layer.id) {

					var novaLayer = {
						label: layer.name,
						id: layer.id,
						ativo: layer.active,
						tipo: layer.tipo,
						cor: layer.color
					}

					that.groups[2].children.push(novaLayer)

				}

			})

		},
		layerChange(data, flag) {

			var dataCopy = Object.assign({}, data)

			if(data.id) {

				var layer

				var pesquisa

				if(flag === true) {

					this.groups.forEach(function(group) {

						if(pesquisa === undefined) {

							if(group.label === 'Áreas a serem regularizadas') {

								pesquisa = group.children.find(camada => (camada.label === data.label && camada.tipo === data.tipo))

							} else {

								pesquisa = group.children.find(camada => camada.label === data.label)

							}

						}

					})

					data = pesquisa

				}

				layer = this.layers.find(layer => layer.id === data.id)

				data.ativo = !data.ativo
				layer.active = !layer.active

				if(layer.active) {

					layer.features.addTo(this.mapa)

				} else {

					this.mapa.removeLayer(layer.features)

				}

			}

			if(flag !== true) {

				this.$parent.$emit('layerChange', dataCopy)

			}

		},
		initMap: function() {

			this.mapa = L.map(this.idMapa.toString(), { preferCanvas: true }).setView([-1.9371875011383266, -48.885329723743084], 13)

			var that = this

			this.mapa.scrollWheelZoom.disable()

			this.tileLayer = L.tileLayer(
				'http://car.semas.pa.gov.br/site/mosaicos/rapid-eye/{z}/{x}/{y}',
				{
					'tms': true,
					'minZoom': 6,
					'maxZoom': 15,
					'maxNativeZoom': 15
				}
			)

			this.tileLayer.addTo(this.mapa)

			this.mapa.zoomControl.setPosition('topright')

			L.easyButton({
				position: 'topright',
				states: [{
					icon: '<svg style="width:20px;height:20px" viewBox="0 0 24 24">\n'
							+ '    <path fill="#000000" d="M12,16L19.36,10.27L21,9L12,2L3,9L4.63,10.27M12,18.54L4.62,12.81L3,14.07L12,21.07L21,14.07L19.37,12.8L12,18.54Z" />\n'
							+ '</svg>',
					onClick: function(btn, map) {

						that.painelCamadas = !that.painelCamadas

						setTimeout(function() {

							that.mapa.invalidateSize()

						}, 0)

					}
				}]
			}).addTo(this.mapa)

			L.easyButton({
				position: 'topright',
				states: [{
					icon: '<svg style="width:20px;height:20px" viewBox="0 0 24 24"> '
							+ '<path fill="#000000" d="M10,21V19H6.41L10.91,14.5L9.5,13.09L5,17.59V14H3V21H10M14.5,10.91L19,6.41V10H21V3H14V5H17.59L13.09,9.5L14.5,10.91Z" /> '
							+ '</svg>',
					onClick: function(btn, map) {

						that.fullscreen = !that.fullscreen

					}
				}]
			}).addTo(this.mapa)

		},
		renderContent(h, { node, data, store }) {

			if(data.ativo !== undefined) {

				if(data.tipo) {

					var css = 'width:15px; height:15px; background-color:' + data.cor + '; margin-right:10px; color: white; font-size: 12px; text-align:center; display: inline-block;'

					if(data.ativo) {

						if(!(this.imovel.condicaoInscricao.id === 1
							|| this.imovel.condicaoInscricao.id === 2
							|| this.imovel.condicaoInscricao.id === 21
							|| this.imovel.condicaoInscricao.id === 22
							|| this.imovel.condicaoInscricao.id === 23)) {

							return (
								<span class="custom-tree-node">
									<svg style="width:15px;height:15px; vertical-align: middle; margin-right:10px" viewBox="0 0 24 24">
										<path fill="#000000" d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z" />
									</svg>
									<span style={css} data-toggle="tooltip" title="Analisado"> A
									</span>
									<span style="font-size: 12px; width: 100%">{node.label}</span>
									<span>
									</span>
								</span>)

						} else {

							if(data.tipo === 'C') {

								return (
									<span class="custom-tree-node">
										<svg style="width:15px;height:15px; vertical-align: middle; margin-right:10px" viewBox="0 0 24 24">
											<path fill="#000000" d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z" />
										</svg>
										<span style={css} data-toggle="tooltip" title="Calculada"> {data.tipo}
										</span>
										<span style="font-size: 12px; width: 100%">{node.label}</span>
										<span>
										</span>
									</span>)

							} else {

								return (
									<span class="custom-tree-node">
										<svg style="width:15px;height:15px; vertical-align: middle; margin-right:10px" viewBox="0 0 24 24">
											<path fill="#000000" d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z" />
										</svg>
										<span style={css} data-toggle="tooltip" title="Declarada"> {data.tipo}
										</span>
										<span style="font-size: 12px; width: 100%">{node.label}</span>
										<span>
										</span>
									</span>)

							}

						}

					} else {

						if(!(this.imovel.condicaoInscricao.id === 1
							|| this.imovel.condicaoInscricao.id === 2
							|| this.imovel.condicaoInscricao.id === 21
							|| this.imovel.condicaoInscricao.id === 22
							|| this.imovel.condicaoInscricao.id === 23)) {

							return (

								<span class="custom-tree-node">
									<svg style="width:15px;height:15px; vertical-align: middle; margin-right:10px" viewBox="0 0 24 24">
										<path fill="#000000" d="M11.83,9L15,12.16C15,12.11 15,12.05 15,12A3,3 0 0,0 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12A3,3 0 0,0 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17A5,5 0 0,1 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.08L19.73,22L21,20.73L3.27,3M12,7A5,5 0 0,1 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.6,4.5 9.26,4.75 8,5.2L10.17,7.35C10.74,7.13 11.35,7 12,7Z" />
									</svg>
									<span style={css} data-toggle="tooltip" title="Analisado"> A
									</span>
									<span style="font-size: 12px; width: 100%">{node.label}</span>
								</span>)

						} else {

							if(data.tipo === 'C') {

								return (
									<span class="custom-tree-node">
										<svg style="width:15px;height:15px; vertical-align: middle; margin-right:10px" viewBox="0 0 24 24">
											<path fill="#000000" d="M11.83,9L15,12.16C15,12.11 15,12.05 15,12A3,3 0 0,0 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12A3,3 0 0,0 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17A5,5 0 0,1 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.08L19.73,22L21,20.73L3.27,3M12,7A5,5 0 0,1 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.6,4.5 9.26,4.75 8,5.2L10.17,7.35C10.74,7.13 11.35,7 12,7Z" />
										</svg>
										<span style={css} data-toggle="tooltip" title="Calculada"> {data.tipo}
										</span>
										<span style="font-size: 12px; width: 100%">{node.label}</span>
										<span>
										</span>
									</span>)

							} else {

								return (
									<span class="custom-tree-node">
										<svg style="width:15px;height:15px; vertical-align: middle; margin-right:10px" viewBox="0 0 24 24">
											<path fill="#000000" d="M11.83,9L15,12.16C15,12.11 15,12.05 15,12A3,3 0 0,0 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12A3,3 0 0,0 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17A5,5 0 0,1 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.08L19.73,22L21,20.73L3.27,3M12,7A5,5 0 0,1 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.6,4.5 9.26,4.75 8,5.2L10.17,7.35C10.74,7.13 11.35,7 12,7Z" />
										</svg>
										<span style={css} data-toggle="tooltip" title="Declarada"> {data.tipo}
										</span>
										<span style="font-size: 12px; width: 100%">{node.label}</span>
										<span>
										</span>
									</span>)

							}

						}

					}

				} else {

					if(data.ativo) {

						return (
							<span class="custom-tree-node">
								<svg style="width:15px;height:15px; vertical-align: middle; margin-right:10px" viewBox="0 0 24 24">
									<path fill="#000000" d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z" />
								</svg>
								<span style="font-size: 12px; width: 100%">{node.label}</span>
							</span>)

					} else {

						return (
							<span class="custom-tree-node">
								<svg style="width:15px;height:15px; vertical-align: middle; margin-right:10px" viewBox="0 0 24 24">
									<path fill="#000000" d="M11.83,9L15,12.16C15,12.11 15,12.05 15,12A3,3 0 0,0 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12A3,3 0 0,0 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17A5,5 0 0,1 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.08L19.73,22L21,20.73L3.27,3M12,7A5,5 0 0,1 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.6,4.5 9.26,4.75 8,5.2L10.17,7.35C10.74,7.13 11.35,7 12,7Z" />
								</svg>
								<span style="font-size: 12px; width: 100%">{node.label}</span>
							</span>)

					}

				}

			} else {

				if(data.classificada) {

					return (
						<span>
							<span style="font-size: 14px; margin-right: 10px">{node.label}</span>
							<span style="width:65px; height:15px; background-color: #FE3F3F; padding: 2px; margin-right:10px; color: white; font-size: 12px; text-align:center; display: inline-block;"> Classificada </span>
							<span>
							</span>
						</span>)

				} else {

					return (
						<span>
							<span style="font-size: 14px">{node.label}</span>
							<span>
							</span>
						</span>)

				}

			}

		},

		initLayers() {

			this.layers.forEach((layer) => {

				const markerFeatures = layer.features.filter(feature => feature.type === 'marker')

				markerFeatures.forEach((feature) => {

					feature.leafletObject = L.marker(feature.coords).bindPopup(feature.name)

				})

			})

		},
		focoMapaImovel() {

			if(this.imovel.geometria) {

				var bounds = new L.GeoJSON(JSON.parse(this.imovel.geometria))
				this.mapa.fitBounds(bounds.getBounds())

			}

		},

		adicionarSideBySide() {

			var that = this

			this.mapa.eachLayer(function(layer) {

				if(layer.options && layer.options.tms) {

					that.mapa.removeLayer(layer)

				}

			})

			var primeiroAno, segundoAno

			// $('.leaflet-sbs').remove()

			this.adicionouConfiguracoes = []

			if(this.ano1 && this.ano2) {

				primeiroAno = this.ano1.toString() + '_rapideye'
				segundoAno = this.ano2.toString() + '_rapideye'

				if(this.ano1 === '2008') {

					primeiroAno = '2008_landsat'

				}

				if(this.ano2 === '2008') {

					segundoAno = '2008_landsat'

				}

				if(this.ano1 === '2015') {

					primeiroAno = '2015_landsat'

				}

				if(this.ano2 === '2015') {

					segundoAno = '2015_landsat'

				}

				if(this.ano1 === '2008') {

					primeiroAno = '2008_landsat'

				}

				if(this.ano2 === '2008') {

					segundoAno = '2008_landsat'

				}

			} else {

				primeiroAno = '2008_landsat'
				segundoAno = '2011_rapideye'

			}

			this.mapa.createPane('background')

			this.mapa.getPane('background').style.zIndex = 0

			var mosaico1 = L.tileLayer('http://sistemas.semas.pa.gov.br/gs_p/gwc/service/tms/1.0.0/mosaicos:mosaico_pa_' + primeiroAno + '@EPSG%3A900913@png/{z}/{x}/{y}.png', {
				tms: true,
				minZoom: 6,
				maxZoom: 15,
				maxNativeZoom: 15,
				pane: 'background'
			}).addTo(this.mapa)

			var mosaico2 = L.tileLayer('http://sistemas.semas.pa.gov.br/gs_p/gwc/service/tms/1.0.0/mosaicos:mosaico_pa_' + segundoAno + '@EPSG%3A900913@png/{z}/{x}/{y}.png', {
				tms: true,
				minZoom: 6,
				maxZoom: 15,
				maxNativeZoom: 15,
				pane: 'background'
			}).addTo(this.mapa)

			var readyMosaico1 = false
			var readyMosaico2 = false

			mosaico1.on('tileloadstart', function() {

				this.loader = true

			})

			mosaico2.on('tileloadstart', function() {

				this.loader = true

			})

			mosaico1.on('load', function() {

				readyMosaico1 = true

				if(readyMosaico2 && readyMosaico1) {

					this.loader = false

				}

			})

			mosaico2.on('load', function() {

				readyMosaico2 = true

				if(readyMosaico2 && readyMosaico1) {

					this.loader = false

				}

			})

			if(this.side != null) {

				that.side.remove()

			}

			this.side = L.control.sideBySide(mosaico1, mosaico2).addTo(this.mapa)

		}
	}
}
</script>




// WEBPACK FOOTER //
// src/components/elements/Mapa.vue